<div class="flex justify-center items-center mt-30">
  <div class="block max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-gray-100">
    <h5 class="mb-2 text-2xl font-bold tracking-tight text-amazone-orange">Insufficient rights!</h5>
    <p class="font-normal text-gray-700">
      You are logged in but you haven't the sufficient rights to access the requested page.
    </p>

    <p class="font-normal text-gray-700">
      Please contact
      <a href="{{ mailLink }}">Team-AEDBIS</a> for support.
    </p>
  </div>
</div>
